import React from "react";
import styles from "./Hero.module.scss";

export function ExploreButton() {
  return (
    // <button className={styles.buttonContainer} tabIndex="0">
    <div>
      <div className={styles.buttonContainer}>
        <div className={styles.buttonInner}>
          <div className={styles.buttonContent}>
            <a
              href="https://apps.apple.com/in/app/troak-interactive-stories/id6739448231"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
              className={styles.buttonContent}
            >
              <div className={styles.buttonText}>Explore</div>
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/c9bafc1ec09d5415c9dea8bcddcab38b806504c94d15553c1510212dcaa9fce0?placeholderIfAbsent=true&apiKey=b8d7041a24ed4a8e80433853cda3ec05"
                className={styles.buttonIcon}
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
